export enum SubscriptionVariant {
	Espresso = "Espresso",
	Filter = "Filter",
}
